module.exports = __webpack_public_path__ + "img/welcome_prof.116728d8.png";